var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"release-list-noData"},[_c('img',{staticClass:"release-list-noData-img",attrs:{"src":_vm.g_imgSrc.bgWhite}}),_c('div',{staticClass:"release-list-noData-word"},[_vm._v("暂无相关内容")])])}
var staticRenderFns = []

export { render, staticRenderFns }